<template>
  <footer class="main-footer">
    <small>Developed Inch-by-Inch with lots of care 💖 by </small><a href="mailto:zutechv2@gmail.com">Zu Ver2.0!</a>.
    <small><strong >Copyright &copy; {{ year }}</strong> All rights reserved.</small>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: 2020
    };
  }
};
</script>
